import React from 'react';
import { RegisterInputContainer } from '../../../../../components/ui/InputSearch';
import { InputElement } from '../../../../../ui/Input/Input';
import { IRegisterForm } from '../../../../../interface/Auth/frontend';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { cleanError } from '../../Phone/slice';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
	isDisabled?: boolean;
}

export const RegFormLastName: React.FC<IProps> = ({ registerForm, setRegisterForm, isDisabled }) => {
	const { t } = useTranslation();
	const { error } = useAppSelector(state => state.auth);
	const dispatch = useAppDispatch();

	return (
		<RegisterInputContainer style={{ marginTop: '16px' }}>
			<InputElement
				placeholder={t('passport.registrationForm.surnameForm.hint')}
				error={error['surname']}
				disabled={isDisabled}
				value={registerForm.surname}
				onChange={value => {
					setRegisterForm({ ...registerForm, surname: value });
					if (error['surname']) {
						dispatch(cleanError('surname'));
					}
				}}
			/>
		</RegisterInputContainer>
	);
};
